module.exports = __webpack_public_path__ + "media/moveproduct.b5ad71a1.mp4";